import {createApp} from 'vue';
import DiffCommitSelector from '../components/DiffCommitSelector/DiffCommitSelector.vue';

export function initDiffCommitSelect() {
  const el = document.querySelector('#diff-commit-select');
  if (!el) return;
  if (el.classList.contains('norender')) return;

  const commitSelect = createApp(DiffCommitSelector);
  commitSelect.mount(el);
}
